import React, { useEffect, useState } from "react";
import Navbar from "./Components/Molecules/Navbar";
import axios from "axios";
import { Switch, Route } from "react-router-dom";
import HomePage from "./Containers/HomePage";
import About from "./Containers/About";
import User from "./Containers/User";

function App() {
  //STATE
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [text, setText] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [user, setUser] = useState({});
  const [repos, setRepos] = useState([]);

  //CALLING USEEFFECT FOR FETCHING INITIAL DATA
  useEffect(() => {
    setLoading(true);

    const res = axios
      .get(
        "https://api.github.com/users?client_id=" +
          process.env.REACT_APP_GITHUB_CLIENT_ID +
          "&client_secret=" +
          process.env.REACT_APP_GITHUB_CLIENT_SECRET
      )
      .then((res) => {
        setUsers(res.data);
        setLoading(false);
        setShowAlert(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  }, []);

  // METHODS

  //GET USER REPOS
  const getUserRepos = async (username) => {
    setLoading(true);
    const res = axios
      .get(
        "https://api.github.com/users/" +
          username +
          "/repos?per_page=5&sort=created:asc&client_id=" +
          process.env.REACT_APP_GITHUB_CLIENT_ID +
          "&client_secret=" +
          process.env.REACT_APP_GITHUB_CLIENT_SECRET
      )
      .then((res) => {
        setRepos(res.data);
        setLoading(false);
        setShowAlert(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  //GET SINGLE GITHUB USER
  const getUser = async (username) => {
    setLoading(true);
    const res = axios
      .get(
        "https://api.github.com/users/" +
          username +
          "?client_id=" +
          process.env.REACT_APP_GITHUB_CLIENT_ID +
          "&client_secret=" +
          process.env.REACT_APP_GITHUB_CLIENT_SECRET
      )
      .then((res) => {
        setUser(res.data);
        setLoading(false);
        setShowAlert(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  //ON TEXT CHANGE HANDLER
  const onChangeHandler = (text) => {
    setText(text);
  };
  //ON CLEARING THE USERS
  const onClearUsers = () => {
    setUsers([]);
  };
  // ON SUBMITING THE NAME OF USER
  const onSubmitHandler = () => {
    console.log(text);
    setShowAlert(false);
    if (text !== "") {
      setLoading(true);
      axios
        .get(
          "https://api.github.com/search/users?q=" +
            text +
            "&client_id=${process.env.REACT_APP_GITHUB_CLIENT_ID}&client_secret=${process.env.REACT_APP_GITHUB_CLIENT_SECRET}"
        )
        .then((res) => {
          console.log("request PUt through");
          setUsers(res.data.items);
          setLoading(false);
          setText("");
        })
        .catch((err) => {
          setLoading(false);
          console.log(err);
        });
    } else {
      setShowAlert(true);
      setTimeout(() => setShowAlert(false), 3000);
    }
  };

  //RETURN FUNCTION
  return (
    <div className="App">
      <Navbar title="Github Finder"></Navbar>
      <Switch>
        <Route path="/about" exact component={About}></Route>
        <Route
          path="/user/:login"
          exact
          render={(props) => (
            <User
              {...props}
              user={user}
              getUser={getUser}
              getUserRepos={getUserRepos}
              repos={repos}
              loading={loading}></User>
          )}></Route>
        <Route
          path="/"
          render={() => (
            <HomePage
              onChangeHandler={onChangeHandler}
              onSubmitHandler={onSubmitHandler}
              onClearUsers={onClearUsers}
              users={users}
              loading={loading}
              text={text}
              showAlert={showAlert}></HomePage>
          )}
        />
      </Switch>
    </div>
  );
}

//EXPORTING THE APP
export default App;
